function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorCircle, HelpCircle } from '@ori-ui/icons';
import { Checkbox, FormControlLabel, Tooltip, Typography, styled } from '@ori-ui/mui';
import { Controller } from 'react-hook-form';
var CheckboxStyled = styled(Checkbox)(function(param) {
    var theme = param.theme;
    return {
        marginTop: theme.spacing(2),
        '& svg': {
            width: '20px',
            height: '20px'
        }
    };
});
var StyledHelpCircle = styled(HelpCircle)(function(param) {
    var theme = param.theme;
    return {
        fontSize: '24px',
        color: theme.palette.grey[300]
    };
});
var LabelWrapper = styled('div')(function(param) {
    var theme = param.theme;
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
});
var LabelStyled = styled(Typography)(function(param) {
    var theme = param.theme;
    return {
        marginRight: theme.spacing(1)
    };
});
export var CheckboxField = function(props) {
    var name = props.name, label = props.label, _props_color = props.color, color = _props_color === void 0 ? 'primary' : _props_color, disabled = props.disabled, required = props.required, inputProps = props.inputProps, icon = props.icon, checkedIcon = props.checkedIcon, tooltipText = props.tooltipText, value = props.value;
    var renderHelpTooltip = function() {
        return /*#__PURE__*/ _jsx(Tooltip, {
            title: tooltipText !== null && tooltipText !== void 0 ? tooltipText : '',
            enterTouchDelay: 0,
            leaveTouchDelay: 5000,
            children: /*#__PURE__*/ _jsx(StyledHelpCircle, {})
        });
    };
    return /*#__PURE__*/ _jsx(Controller, {
        name: name,
        defaultValue: value !== null && value !== void 0 ? value : false,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            return /*#__PURE__*/ _jsx(FormControlLabel, {
                label: /*#__PURE__*/ _jsxs(LabelWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(LabelStyled, {
                            variant: "body1",
                            children: label
                        }),
                        error ? /*#__PURE__*/ _jsx(ErrorCircle, {
                            color: "error"
                        }) : renderHelpTooltip()
                    ]
                }),
                control: /*#__PURE__*/ _jsx(CheckboxStyled, _object_spread_props(_object_spread({}, field), {
                    id: name,
                    checked: field.value,
                    value: field.value,
                    inputRef: field.ref,
                    color: color,
                    disabled: disabled,
                    required: required,
                    inputProps: inputProps,
                    icon: icon,
                    checkedIcon: checkedIcon
                })),
                sx: {
                    alignItems: 'center',
                    height: '25px'
                },
                id: name
            });
        }
    });
};
